import { render, staticRenderFns } from "./FrontEndHeader.vue?vue&type=template&id=49779151"
import script from "./FrontEndHeader.vue?vue&type=script&lang=js"
export * from "./FrontEndHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports